module.exports = __webpack_public_path__ + "img/中通快递.bd52156d.png";